import type { SessionStepModule } from '../types';
import { QuestionnaireDetail } from './QuestionnaireDetail';
import { QuestionnaireStepRunner } from './QuestionnaireStepRunner';
import { isQuestionnaireStep } from './questionnaire.utils';

// Questionnaire step — collects the applicant's answers to a form the tenant designed.
// The second module that calls no provider (Document Template was the first).
export const questionnaireStepModule: SessionStepModule = {
  key: 'questionnaire',
  matches: isQuestionnaireStep,
  Runner: QuestionnaireStepRunner,
  Detail: QuestionnaireDetail,
};
